import { TextIconGroupCombinedProps } from './types';

const usePresenter = (props: TextIconGroupCombinedProps): TextIconGroupCombinedProps => {
  return props;
};

export default usePresenter;
